import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import { LinkButton } from '@clds/button';
import EmptyState from '@cld/empty-state';

import { useMessage } from '../i18n/useMessage';
import { modules } from '../components/side-menu/side-menu.constants';

export const PageNotFound = () => {
  const t = useMessage();
  const navigate = useNavigate();
  const onActionButtonClick = () => {
    navigate(modules.dashboard);
  };

  return (
    <>
      <Helmet title={`${t('page-not-found-title')} | ${t('default-page-title')}`} />
      <EmptyState
        title={t('page-not-found-title')}
        imageSrc="https://res.cloudinary.com/prod/image/upload/media-management/empty-states/not-found.svg"
        imageWidth={175}
        data-test="pm-page-not-found"
      >
        <LinkButton size={'md'} onClick={onActionButtonClick}>
          {t('page-not-found-action')}
        </LinkButton>
      </EmptyState>
    </>
  );
};
